import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderCheckbox = ({
    schemaItem,
    item,
    columnKey,
}: TableCellProps) => {
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            <ux-checkbox value={item[columnKey]}></ux-checkbox>
        </td>
    );
};
